import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import "./FoodDelivery.css";
import ServiceFooter from "../../ServiceFooter";
import { keyData } from "./data";
import { useState } from "react";
import FoodDeliveryKey from "./FoodDeliveryKey";
import { Navigation, A11y, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const FoodDelivery = () => {
  const [activeKeyIndex, setActiveKeyIndex] = useState(null);

  const handleKeyShow = (index) => {
    setActiveKeyIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // Steps
  const [isPrevStepsDisabled, setIsPrevStepsDisabled] = useState(true);
  const [isNextStepsDisabled, setIsNextStepsDisabled] = useState(false);

  const handleStepsChange = (StepsSwiper) => {
    setIsPrevStepsDisabled(StepsSwiper.isBeginning);
    setIsNextStepsDisabled(StepsSwiper.isEnd);
  };

  // why Choose
  const [isPrevChooseDisabled, setIsPrevChooseDisabled] = useState(true);
  const [isNextChooseDisabled, setIsNextChooseDisabled] = useState(false);

  const handleChooseChange = (ChooseSwiper) => {
    setIsPrevChooseDisabled(ChooseSwiper.isBeginning);
    setIsNextChooseDisabled(ChooseSwiper.isEnd);
  };

  // how to Choose
  const [isPrevhowDisabled, setIsPrevhowDisabled] = useState(true);
  const [isNexthowDisabled, setIsNexthowDisabled] = useState(false);

  const handlehowChange = (howSwiper) => {
    setIsPrevhowDisabled(howSwiper.isBeginning);
    setIsNexthowDisabled(howSwiper.isEnd);
  };

  return (
    <>
      <NewHead />

      <Helmet>
        <title> Food delivery app development company</title>

        <meta name="title" content=" Food delivery app development company " />
        <meta
          name="description"
          content="Whether you are a startup, restaurant owner, or entrepreneur, having a feature-rich and scalable food delivery app can transform your business. Get Free Consultation from us."
        />

        <meta
          property="og:title"
          content=" Food delivery app development company"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/food-delivery-app-development-company"
        />
      </Helmet>

      <main className="fd-main">
        {/* hero */}
        <article className="fd-hero primary__landing__container fd-mb-100">
          <h1 className="fd-hero-title">
            {" "}
            <span className="fd-span">Food delivery app</span> development
            company
          </h1>
          <div className="fd-hero-btn-wrap">
            <button
              data-toggle="modal"
              data-target="#myModal"
              className="fd-hero-btn"
            >
              Get Free Consultation
              <span className="mx-2 ">
                <i className="fa-solid fa-arrow-right"></i>
              </span>
            </button>
          </div>

          <div className="fd-hero-img-wrap">
            <img
              src={require("../../../image/FoodDelivery/hero-one.webp")}
              alt="Food delivery app development company"
            />
          </div>

          <img
            src={require("../../../image/FoodDelivery/hero-tl.webp")}
            className="fd-hero-tl"
            alt="Food delivery app development company"
          />
          <img
            src={require("../../../image/FoodDelivery/hero-bl.webp")}
            className="fd-hero-bl"
            alt="Food delivery app development company"
          />
          <img
            src={require("../../../image/FoodDelivery/hero-tr.webp")}
            className="fd-hero-tr"
            alt="Food delivery app development company"
          />
          <img
            src={require("../../../image/FoodDelivery/hero-br.webp")}
            className="fd-hero-br"
            alt="Food delivery app development company"
          />
        </article>

        {/* about */}
        <article className="fd-about primary__landing-content-container fd-mb-100">
          <div className="row fd-about-row mx-0">
            <div className="col-lg-6">
              <h3 className="fd-subtitle">
                What is <span className="fd-span">food delivery app</span>{" "}
                development ?
              </h3>
              <p className="fd-subcontent">
                Food delivery app development refers to the process of creating
                a mobile application that allows customers to order food from
                restaurants, cafes, or other food vendors through their
                smartphones or other devices. These apps typically handle the
                entire process of food ordering, from browsing menus and placing
                an order to tracking deliveries and processing payments.
              </p>

              <button
                data-toggle="modal"
                data-target="#myModal"
                className="primary-landing-main-btn re-hero-btn fd-btn"
              >
                <div className="re-btn-txt">Get Demo</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
            <div className="col-lg-6 fd-about-right-col">
              <img
                src={require("../../../image/FoodDelivery/about.webp")}
                alt="Food delivery app development company"
              />
            </div>
          </div>
        </article>

        {/* purpose */}
        <div className="primary__landing-content-container fd-purpose-outer">
          <article className="fd-purpose  fd-mb-100">
            <div className="row mx-0 fd-purpose-row">
              <div className="col-lg-6 fd-purpose-left-col">
                <img
                  src={require("../../../image/FoodDelivery/purpose-one.webp")}
                  alt="Food delivery app development company"
                />
              </div>
              <div className="col-lg-6">
                <h3 className="fd-subtitle text-white">
                  Purpose of Food Delivery Apps
                </h3>
                <p className="fd-subcontent text-white">
                  Food delivery apps are designed to make it easier for people
                  to order meals without having to visit restaurants physically.
                  They offer several features that make the process efficient
                  for customers, delivery personnel, and restaurant owners.
                  Customers can search for food, place orders, and have meals
                  delivered to their doorsteps with a few taps.
                </p>
                <button
                  data-toggle="modal"
                  data-target="#myModal"
                  className="primary-landing-main-btn re-hero-btn fd-btn fd-purpose-btn"
                >
                  <div className="re-btn-txt">Get Start Now</div>
                  <span className="mx-2 right-arr">
                    <i className="fa-solid fa-arrow-right"></i>
                  </span>
                </button>
              </div>
            </div>
          </article>
        </div>

        <div>
          {/* types */}
          <article className="fd-types ">
            <div className="primary__landing-content-container">
              <h3 className="fd-subtitle fd-type-title">
                <span className="fd-span">Types of</span> Food Delivery Apps
              </h3>
              <p className="fd-subcontent fd-type-content">
                Food delivery apps come in various forms, catering to different
                needs. Understanding the type of app you need is crucial before
                embarking on the development process.
              </p>

              <div className="row fd-type-row mx-0 gx-xl-5 gx-lg-3 g-4">
                <div className="col-lg-4 col-md-6">
                  <div className="fd-type-card">
                    <img
                      src={require("../../../image/FoodDelivery/type-img-one.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Restaurant-to-Consumer Model (R2C)</h5>
                    <p>
                      In this model, restaurants handle the food preparation and
                      delivery. The app acts as a bridge, connecting consumers
                      with restaurants and enabling seamless ordering and
                      delivery.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="fd-type-card">
                    <img
                      src={require("../../../image/FoodDelivery/type-img-two.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Platform-to-Consumer Model (P2C)</h5>
                    <p>
                      The platform manages the logistics of the entire process,
                      from order to delivery. Popular examples include Uber Eats
                      and Grubhub.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="fd-type-card">
                    <img
                      src={require("../../../image/FoodDelivery/type-img-three.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Grocery and Food Delivery Model</h5>
                    <p>
                      Apps like Instacart and Postmates combine food delivery
                      with grocery shopping, enabling users to purchase not only
                      meals but also groceries and other goods.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </article>

          {/* importace */}
          <article className="fd-importance fd-mb-100">
            <div className="fd-imp-inner primary__landing__container">
              <div className="row fd-imp-row mx-0">
                <div className="col-lg-6">
                  <div className="fd-imp-left">
                    <h3 className="fd-subtitle">
                      Importance of a{" "}
                      <span className="fd-span">Food Delivery App</span>{" "}
                      Development Company
                    </h3>
                    <p className="fd-subcontent">
                      A skilled food delivery app development company will have
                      the expertise and resources to build your app according to
                      the latest trends and standards. Choosing the right
                      company is crucial for the success of your app. A reliable
                      development team can
                    </p>

                    <div className="fd-icon-flex-container">
                      <div className="fd-imp-icon-left">
                        <div className="fd-imp-icon-flex">
                          <div className="fd-imp-icon-wrap">
                            <img
                              src={require("../../../image/FoodDelivery/fd-imp-one.webp")}
                              alt="Food delivery app development company"
                            />
                          </div>
                          <h6>
                            Provide insights into the latest industry trends
                          </h6>
                        </div>
                      </div>
                      <div className="fd-imp-icon-right">
                        <div className="fd-imp-icon-flex">
                          <div className="fd-imp-icon-wrap">
                            <img
                              src={require("../../../image/FoodDelivery/fd-imp-two.webp")}
                              alt="Food delivery app development company"
                            />
                          </div>
                          <h6>Help you define your app's unique features</h6>
                        </div>
                      </div>
                    </div>
                    <div className="fd-icon-flex-container two">
                      <div className="fd-imp-icon-left">
                        <div className="fd-imp-icon-flex">
                          <div className="fd-imp-icon-wrap">
                            <img
                              src={require("../../../image/FoodDelivery/fd-imp-three.webp")}
                              alt="Food delivery app development company"
                            />
                          </div>
                          <h6>Ensure the app's scalability and security</h6>
                        </div>
                      </div>
                      <div className="fd-imp-icon-right">
                        <div className="fd-imp-icon-flex">
                          <div className="fd-imp-icon-wrap">
                            <img
                              src={require("../../../image/FoodDelivery/fd-imp-four.webp")}
                              alt="Food delivery app development company"
                            />
                          </div>
                          <h6>
                            Ensure timely delivery of the app while staying
                            within budget.
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <img
                    src={require("../../../image/FoodDelivery/importance.webp")}
                    alt="Food delivery app development company"
                  />
                </div>
              </div>
            </div>
          </article>
        </div>

        {/* key features */}
        <article className="fd-key primary__landing-content-container fd-mb-100">
          <h3 className="fd-subtitle fd-key-mw">
            Key Features of <span className="fd-span">a Food Delivery</span> App
            Development
          </h3>
          <p className="fd-subcontent fd-key-content-mw">
            A food delivery app development company incorporates multiple
            essential features to ensure seamless functionality
          </p>

          <div className="row fd-key-row mx-0">
            <div className="col-lg-6 fd-key-lft-col">
              <img
                src={require("../../../image/FoodDelivery/key.webp")}
                alt="Food delivery app development company"
              />
            </div>

            <div className="col-lg-6">
              {keyData.map((data, index) => {
                return (
                  <FoodDeliveryKey
                    data={data}
                    key={data.id}
                    showIndex={activeKeyIndex === index}
                    handleShow={() => handleKeyShow(index)}
                  />
                );
              })}
            </div>
          </div>
        </article>

        {/* steps */}
        <article className="fd-step primary__landing__container fd-mb-100">
          <h3 className="fd-subtitle fd-step-title">
            Steps <span className="fd-span">to Develop</span> a Food Delivery
            App
          </h3>
          <p className="fd-subcontent fd-step-content">
            A food delivery app development company follows a systematic
            approach to ensure the successful launch of your app.
          </p>

          <div>
            <Swiper
              className="fd-step-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".fd-st-prev-arr",
                nextEl: ".fd-st-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handleStepsChange}
              onReachBeginning={() => setIsPrevStepsDisabled(true)}
              onReachEnd={() => setIsNextStepsDisabled(true)}
              onFromEdge={() => {
                setIsPrevStepsDisabled(false);
                setIsNextStepsDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="fd-step-card">
                  <div className="fd-step-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/step-img-one.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <h6>Market Research & Planning</h6>
                  <p>
                    Conducting extensive market research helps identify the
                    target audience, competitors, and industry trends.
                  </p>

                  <div className="fd-step-num-wrap">01</div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-step-card">
                  <div className="fd-step-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/step-img-two.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <h6>UI/UX Design</h6>
                  <p>
                    Creating an intuitive and visually appealing design to
                    enhance user experience.
                  </p>

                  <div className="fd-step-num-wrap">02</div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-step-card">
                  <div className="fd-step-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/step-img-three.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <h6>App Development</h6>
                  <p>
                    Developing the front-end, back-end, and database integration
                    for seamless performance.
                  </p>

                  <div className="fd-step-num-wrap">03</div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-step-card">
                  <div className="fd-step-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/step-img-four.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <h6>Testing & Quality Assurance</h6>
                  <p>
                    Ensuring the app is bug-free and performs efficiently across
                    various devices.
                  </p>

                  <div className="fd-step-num-wrap">04</div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-step-card">
                  <div className="fd-step-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/step-img-five.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <h6>Deployment & Launch</h6>
                  <p>
                    Deploying the app on the App Store and Google Play Store for
                    users to download.
                  </p>

                  <div className="fd-step-num-wrap">05</div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-step-card">
                  <div className="fd-step-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/step-img-six.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <h6>Post-Launch Support</h6>
                  <p>
                    Regular updates and technical support to ensure app
                    stability and scalability.
                  </p>

                  <div className="fd-step-num-wrap">06</div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`fd-st-prev-arr ${
                  isPrevStepsDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevStepsDisabled ? "#000000" : "#000000",
                  cursor: isPrevStepsDisabled ? "not-allowed" : "pointer",
                  background: isPrevStepsDisabled ? "#808080" : "#ffffff",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`fd-st-next-arr ${
                  isNextStepsDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNextStepsDisabled ? "#000000" : "#000000",
                  cursor: isNextStepsDisabled ? "not-allowed" : "pointer",
                  background: isNextStepsDisabled ? "#808080" : "#ffffff",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* cost */}
        <article className="fd-cost primary__landing-content-container fd-mb-100">
          <div className="row mx-0 fd-cost-row">
            <div className="col-xl-5 fd-cost-left-col">
              <img
                src={require("../../../image/FoodDelivery/cost.webp")}
                alt="Food delivery app development company"
              />
            </div>
            <div className="col-xl-7">
              <h3 className="fd-subtitle">
                <span className="fd-span">Cost of </span>
                Food Delivery <span className="fd-span">App Development</span>
              </h3>
              <p className="fd-subcontent fd-ct-content-mw">
                The cost of hiring a food delivery app development company
                depends on various factors such as
              </p>

              <div className="row m-0 g-md-5 g-2 fd-cost-icon-row">
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/cost-img-one.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>App Complexity</h6>
                    <p>Basic, mid-level, or advanced features.</p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/cost-img-two.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Technology Stack</h6>
                    <p>Basic, mid-level, or advanced features.</p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/cost-img-three.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Development Team Size</h6>
                    <p>
                      Number of developers, designers, and QA testers involved.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/cost-img-four.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Time Frame</h6>
                    <p>Duration required to complete the project.</p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/cost-img-five.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Third-Party Integrations</h6>
                    <p>
                      Payment gateways, GPS tracking, and other integrations.
                    </p>
                  </div>
                </div>
              </div>

              <p className="fd-subcontent fd-ct-content-mw fd-ct-btm-content">
                On average, the development cost ranges from $10,000 to $100,000
                based on app complexity and features.
              </p>
            </div>
          </div>
        </article>

        {/* benefits */}
        <article className="fd-benefits primary__landing__container fd-mb-100">
          <h3 className="fd-subtitle fd-ben-mw">
            Benefits of{" "}
            <span className="fd-span">Investing in a Food Delivery App </span>{" "}
            Development
          </h3>
          <p className="fd-subcontent text-center mt-3">
            Partnering with a food delivery app development company offers
            numerous advantages
          </p>

          <div className="row mx-0 fd-ben-row">
            <div className="col-xl-6 ">
              <div className="row m-0 g-4 fd-cost-icon-row mb-xl-5">
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/ben-img-one.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Increased Revenue Streams</h6>
                    <p>
                      Earn through commissions, subscriptions, and
                      advertisements.
                    </p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/ben-img-two.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Enhanced Customer Experience</h6>
                    <p>Provide seamless ordering and delivery services.</p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/ben-img-three.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Wider Market Reach</h6>
                    <p> Expand your customer base and attract new users.</p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/ben-img-four.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Brand Recognition</h6>
                    <p>Build trust and credibility in the market.</p>
                  </div>
                </div>
                <div className="col-md-6 fd-ct-col">
                  <div className="fd-cost-icon-wrap">
                    <img
                      src={require("../../../image/FoodDelivery/ben-img-five.webp")}
                      alt="Food delivery app development company"
                    />
                  </div>
                  <div className="fd-cost-icon-content">
                    <h6>Data-Driven Insights</h6>
                    <p>
                      Use analytics to improve business strategies and customer
                      engagement.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 fd-cost-left-col">
              <img
                src={require("../../../image/FoodDelivery/benefits.webp")}
                alt="Food delivery app development company"
              />
            </div>
          </div>

          <img
            src={require("../../../image/FoodDelivery/ben-lft.webp")}
            alt="Food delivery app development company"
            className="fd-ben-lft"
          />
          <img
            src={require("../../../image/FoodDelivery/ben-rgt.webp")}
            alt="Food delivery app development company"
            className="fd-ben-rgt"
          />
        </article>

        {/* trends */}
        <article className="fd-trends primary__landing-content-container fd-mb-100">
          <h3 className="fd-subtitle text-center">
            Trends in <span className="fd-span">the Food Delivery </span>{" "}
            Industry
          </h3>
          <p className="fd-subcontent fd-key-mw">
            As the food delivery industry continues to evolve, staying updated
            with trends is critical for staying competitive
          </p>

          <div className="row mx-0 fd-trends-row g-5 g-lg-0">
            <div className="col-lg-4 col-md-6">
              <div className="fd-trends-card">
                <img
                  src={require("../../../image/FoodDelivery/trend-img-one.webp")}
                  alt="Food delivery app development company"
                />
                <h6 className="fd-trends-card-title">
                  AI and Machine Learning
                </h6>
                <p className="fd-trends-card-content">
                  Personalization of user experiences and better demand
                  forecasting.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="fd-trends-card">
                <img
                  src={require("../../../image/FoodDelivery/trend-img-two.webp")}
                  alt="Food delivery app development company"
                />
                <h6 className="fd-trends-card-title">Ghost Kitchens</h6>
                <p className="fd-trends-card-content">
                  Restaurants that operate exclusively through delivery apps to
                  reduce overhead costs.
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="fd-trends-card">
                <img
                  src={require("../../../image/FoodDelivery/trend-img-three.webp")}
                  alt="Food delivery app development company"
                />
                <h6 className="fd-trends-card-title">Sustainability</h6>
                <p className="fd-trends-card-content">
                  Focus on reducing packaging waste and promoting eco-friendly
                  delivery options.
                </p>
              </div>
            </div>
          </div>
        </article>

        {/* why choose */}
        <article className="fd-choose fd-mb-100">
          <div className="primary__landing-content-container">
            <h3 className="fd-subtitle fd-key-mw text-white">
              Why Choose <span className="fd-span">a Food Delivery App</span>{" "}
              Development Company?
            </h3>
            <p className="fd-subcontent fd-choose-content">
              A professional food delivery app development company ensures that
              your app meets market demands, provides an excellent user
              experience, and integrates advanced technologies for seamless
              operations. Here are some reasons why you should hire a
              specialized company
            </p>

            <div>
              <Swiper
                className="fd-step-swiper fd-choose-swiper"
                spaceBetween={30}
                slidesPerView={3}
                modules={[Navigation, A11y, Pagination]}
                pagination={{
                  clickable: true,
                }}
                scrollbar={{ draggable: true }}
                navigation={{
                  prevEl: ".fd-ch-prev-arr",
                  nextEl: ".fd-ch-next-arr",
                }}
                breakpoints={{
                  320: {
                    slidesPerView: 1,
                    spaceBetween: 10,
                  },
                  480: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                  },
                  1025: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                  },
                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                onSlideChange={handleChooseChange}
                onReachBeginning={() => setIsPrevChooseDisabled(true)}
                onReachEnd={() => setIsNextChooseDisabled(true)}
                onFromEdge={() => {
                  setIsPrevChooseDisabled(false);
                  setIsNextChooseDisabled(false);
                }}
              >
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-one.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>Expertise in App Development</h5>
                    <p>
                      Skilled developers create high-performance apps with
                      modern features.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-two.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>Custom Solutions</h5>
                    <p>
                      Tailor-made applications designed to meet your business
                      requirements.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-three.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>Advanced Technology Integration</h5>
                    <p>
                      AI, ML, and cloud-based solutions enhance user experience.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-four.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>User-Friendly Interface</h5>
                    <p>
                      Simple navigation and smooth UI enhance customer
                      engagement.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-five.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>Scalability</h5>
                    <p>
                      Apps that can handle increasing users and business
                      expansion.
                    </p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-six.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>Security and Compliance</h5>
                    <p>Ensures data protection and regulatory compliance.</p>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  <div className="fd-choose-card">
                    <div className="fd-ch-icon-wrap">
                      <img
                        src={require("../../../image/FoodDelivery/choose-img-seven.webp")}
                        alt="Food delivery app development company"
                      />
                    </div>
                    <h5>Post-Launch Support</h5>
                    <p>
                      Regular updates and maintenance to keep the app running
                      smoothly.
                    </p>
                  </div>
                </SwiperSlide>
              </Swiper>

              <div className="fd-step-btn-wrap">
                <button
                  className={`fd-ch-prev-arr ${
                    isPrevChooseDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isPrevChooseDisabled ? "#000000" : "#000000",
                    cursor: isPrevChooseDisabled ? "not-allowed" : "pointer",
                    background: isPrevChooseDisabled ? "#808080" : "#ffffff",
                  }}
                >
                  <i className="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  className={`fd-ch-next-arr ${
                    isNextChooseDisabled ? "disabled" : ""
                  }`}
                  style={{
                    color: isNextChooseDisabled ? "#000000" : "#000000",
                    cursor: isNextChooseDisabled ? "not-allowed" : "pointer",
                    background: isNextChooseDisabled ? "#808080" : "#ffffff",
                  }}
                >
                  <i className="fa-solid fa-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </article>

        {/* how to choose */}
        <article className="fd-hw-choose primary__landing-content-container fd-mb-100">
          <h3 className="fd-subtitle fd-hw-ch-mw">
            How to Choose{" "}
            <span className="fd-span">the Right Food Delivery App </span>{" "}
            Development Company?
          </h3>
          <p className="fd-subcontent fd-hw-content-mw">
            Selecting the best food delivery app development company is crucial
            for your project's success. Consider the following factors
          </p>

          <div>
            <Swiper
              className="fd-step-swiper fd-choose-swiper fd-hw-swiper"
              spaceBetween={30}
              slidesPerView={3}
              modules={[Navigation, A11y, Pagination]}
              pagination={{
                clickable: true,
              }}
              scrollbar={{ draggable: true }}
              navigation={{
                prevEl: ".fd-hw-prev-arr",
                nextEl: ".fd-hw-next-arr",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                480: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                },
                1025: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
              }}
              onSlideChange={handlehowChange}
              onReachBeginning={() => setIsPrevhowDisabled(true)}
              onReachEnd={() => setIsNexthowDisabled(true)}
              onFromEdge={() => {
                setIsPrevhowDisabled(false);
                setIsNexthowDisabled(false);
              }}
            >
              <SwiperSlide>
                <div className="fd-hw-card-outer">
                  <div className="fd-hw-card-inner">
                    <img
                      src={require("../../../image/FoodDelivery/hw-img-one.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Portfolio & Experience</h5>
                    <p>
                      Check their previous projects and expertise in food
                      delivery app development.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-hw-card-outer">
                  <div className="fd-hw-card-inner">
                    <img
                      src={require("../../../image/FoodDelivery/hw-img-two.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Client Testimonials</h5>
                    <p>Read reviews and feedback from past clients.</p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-hw-card-outer">
                  <div className="fd-hw-card-inner">
                    <img
                      src={require("../../../image/FoodDelivery/hw-img-three.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Technical Proficiency </h5>
                    <p>
                      Ensure they use the latest technologies and frameworks.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-hw-card-outer">
                  <div className="fd-hw-card-inner">
                    <img
                      src={require("../../../image/FoodDelivery/hw-img-four.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Customization Options </h5>
                    <p>
                      The company should offer tailor-made solutions for your
                      business.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-hw-card-outer">
                  <div className="fd-hw-card-inner">
                    <img
                      src={require("../../../image/FoodDelivery/hw-img-five.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Post-Development Support </h5>
                    <p>
                      Opt for a company that provides maintenance and updates.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="fd-hw-card-outer">
                  <div className="fd-hw-card-inner">
                    <img
                      src={require("../../../image/FoodDelivery/hw-img-six.webp")}
                      alt="Food delivery app development company"
                    />
                    <h5>Cost & Budget</h5>
                    <p>
                      Compare pricing models and choose the best value-for-money
                      service.
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>

            <div className="fd-step-btn-wrap">
              <button
                className={`fd-hw-prev-arr ${
                  isPrevhowDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isPrevhowDisabled ? "#ffffff8f" : "#fff",
                  cursor: isPrevhowDisabled ? "not-allowed" : "pointer",
                  background: isPrevhowDisabled ? "#808080" : "#000",
                }}
              >
                <i className="fa-solid fa-chevron-left"></i>
              </button>
              <button
                className={`fd-hw-next-arr ${
                  isNexthowDisabled ? "disabled" : ""
                }`}
                style={{
                  color: isNexthowDisabled ? "#ffffff8f" : "#fff",
                  cursor: isNexthowDisabled ? "not-allowed" : "pointer",
                  background: isNexthowDisabled ? "#808080" : "#000",
                }}
              >
                <i className="fa-solid fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </article>

        {/* Take Away*/}
        <div className="rs-mt-100 custom-get-in-touch ply-ta">
          <div className="primary__landing-content-container ">
            <h5 className="custom-get-title ph-take-title dt-get-title">
              Take Away
            </h5>
            <p className="custom-get-content dt-get-content">
              Choosing the right food delivery app development company is
              essential to building a successful online food delivery platform.
              With advanced features, seamless UI/UX, and robust backend
              technology, you can create an app that meets customer expectations
              and drives business growth. If you are looking for a reliable food
              delivery app development company, ensure they have the right
              expertise, experience, and technology stack to bring your vision
              to life.
            </p>

            <div className="d-flex align-items-center justify-content-center">
              <button
                data-toggle="modal"
                data-target="#myModal"
                className="fiu-need-left-btn mt-4 re-hero-btn "
              >
                <div className="re-btn-txt">Get Free Consultation</div>
                <span className="mx-2 right-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>
            </div>
          </div>
        </div>
      </main>

      {/* faq */}
      <article className="primary__landing-content-container">
        <div className="landing-faq-wrapper">
          <div className="row">
            <div className="col-lg-6">
              <h6 className="landing-faq-left-title">
                Frequently Asked <span className="faq-span">Questions.</span>{" "}
                {""}
              </h6>
            </div>
            <div className="col-lg-6">
              <div>
                <div className="container">
                  <div className="accordion" id="faq">
                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead1">
                        <button
                          className="landing-faq-title collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#faq1"
                          aria-expanded="true"
                          aria-controls="faq1"
                        >
                          How much time is required to develop a food delivery
                          app?
                        </button>
                      </div>

                      <div
                        id="faq1"
                        className="collapse"
                        aria-labelledby="faqhead1"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          The development timeline for a food delivery app can
                          range from 3 to 9 months, depending on the app’s
                          complexity and features. The process involves stages
                          like research, design, development, testing, and
                          deployment.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead2">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq2"
                          aria-expanded="true"
                          aria-controls="faq2"
                        >
                          Do I need a separate app for restaurants and drivers?
                        </div>
                      </div>

                      <div
                        id="faq2"
                        className="collapse"
                        aria-labelledby="faqhead2"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Yes, it's common to create separate apps for
                          customers, restaurants, and drivers, each tailored to
                          their specific needs. This ensures a seamless user
                          experience and efficient management for all parties
                          involved in the food delivery process.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead3">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq3"
                          aria-expanded="true"
                          aria-controls="faq3"
                        >
                          What makes a food delivery app a profitable
                          investment?
                        </div>
                      </div>

                      <div
                        id="faq3"
                        className="collapse"
                        aria-labelledby="faqhead3"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          A food delivery app can be profitable due to its
                          growing demand in both urban and rural areas, the
                          scalability of the business model, and the potential
                          for partnerships with restaurants and delivery
                          drivers. The key lies in a seamless user experience,
                          strong market positioning, and efficient logistics
                          management.
                        </div>
                      </div>
                    </div>

                    <div className="landing-faq-card">
                      <div className="landing-faq-header" id="faqhead4">
                        <div
                          className="landing-faq-title collapsed"
                          data-toggle="collapse"
                          data-target="#faq4"
                          aria-expanded="true"
                          aria-controls="faq4"
                        >
                          How can a food delivery app scale in new markets?
                        </div>
                      </div>

                      <div
                        id="faq4"
                        className="collapse"
                        aria-labelledby="faqhead4"
                        data-parent="#faq"
                      >
                        <div className="landing-faq-content">
                          Scaling a food delivery app in new markets involves
                          adapting to local preferences, building partnerships
                          with regional restaurants, and ensuring a reliable
                          delivery network. Effective marketing, local
                          partnerships, and strategic pricing can help increase
                          market penetration and customer acquisition.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>

      <ServiceFooter />
    </>
  );
};

export default FoodDelivery;
